import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء

// إعداد Axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});



// NotificationApi.js
export const sendNotification = (formData) => {
  const token = localStorage.getItem("authToken");
  return api.post(
    `send/notification/?api_password=${API_PASSWORD}`,
    formData,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// 📌 جلب إشعارات المستأجر
export const getTenantNotification = (tenant) => {
  const token = localStorage.getItem("authToken");

  // ⚠️ لاحظ إن API نفسه مكتوب فيه غلط (tennat / notificatin)
  return api.get(
    `get/tenant/notificatin/${tenant}?api_password=${API_PASSWORD}`,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );
};